import { Button } from "@babackapp/ui/components/button";
import { ContextualTipsTrigger } from "@babackapp/ui/components/contextual-tips";
import {
  FloatingPanel,
  FloatingPanelGroup,
  FloatingPanelHeader,
  FloatingPanelSeparator,
} from "@babackapp/ui/components/floating-panel";
import { useTranslation } from "react-i18next";
import { LayoutGrid, PaintBucket, Send } from "lucide-react";
import { useState } from "react";
import { useFormContext } from "react-hook-form";
import { useTemplatesEditorSettings } from "../../context/templates-editor-settings-context";
import { EmailTemplateFormData } from "../../types";
import SendTestEmailPanel from "../send-test-email-panel";
import { TempalteListDialog } from "../template-list-dialog";
import LeftSidebarBlocksPanel from "./left-sidebar-blocks-panel";
import LeftSidebarEditionPanel from "./left-sidebar-edition-panel";

export function LeftSidebar() {
  const [isSendTestEmailPanelOpen, setIsSendTestEmailPanelOpen] =
    useState(false);

  const { watch } = useFormContext<EmailTemplateFormData>();
  const title = watch("title");
  const type = watch("type");

  return (
    <div className={`relative z-[50] pointer-events-none`}>
      <FloatingPanelGroup className="relative pointer-events-auto">
        <FloatingPanel className="relative">
          <FloatingPanelHeader className="flex items-center justify-between">
            <TempalteListDialog>
              <span className="font-medium flex items-center gap-1 flex-1 cursor-pointer">
                <LayoutGrid className="size-4" />
                {title}
              </span>
            </TempalteListDialog>
            <div className="flex items-center justify-end gap-2">
              <EmailsThemeButton />
              {type === "email" &&
								<Button
									size="icon"
									variant="ghost"
									onClick={() => setIsSendTestEmailPanelOpen(true)}
									title="Send test email"
									className="w-auto h-auto"
								>
									<Send className="size-3" />
								</Button>
              }
            </div>
          </FloatingPanelHeader>
          <FloatingPanelSeparator />
          <LeftSidebarEditionPanel />

          {isSendTestEmailPanelOpen && (
            <SendTestEmailPanel
              onClose={() => setIsSendTestEmailPanelOpen(false)}
            />
          )}
        </FloatingPanel>

        <LeftSidebarBlocksPanel />
      </FloatingPanelGroup>
    </div>
  );
}

function EmailsThemeButton() {
  const { t } = useTranslation("trackoffice");
  const { openThemeSettings } = useTemplatesEditorSettings();

  return (
    <>
      <ContextualTipsTrigger
        wrapped
        tips={[
          {
            id: "template-theme",
            title: t(
              "templatesEditor.tips.templateTheme.title",
              "Customize the emails theme",
            ),
            description: t(
              "templatesEditor.tips.templateTheme.description",
              "This theme is common to all your emails, so you only need to customize it once. You can change the colors, border radius, and more.",
            ),
          },
        ]}
      >
        <Button
          size="icon"
          variant="ghost"
          onClick={openThemeSettings}
          title="Edit emails theme"
          className="w-auto h-auto"
        >
          <PaintBucket className="size-4" />
        </Button>
      </ContextualTipsTrigger>
    </>
  );
}
